// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2eroS","buttons":"Footer_buttons__2QpAA"};